import { BrowserRouter, Route, Routes } from 'react-router-dom';

//User Everyone
import AnaSayfa from './pages/Home/Home.jsx';
import LocationPage from './pages/LocationPage.jsx';
import CommunicationPage from './pages/CommunicationPage.jsx';
import AboutPage from './pages/AboutPage.jsx';
import ContactusPage from './pages/ContactusPage.jsx';
import ProjectsPage from './pages/ProjectsPage.jsx';
import CorporatePage from './pages/CorporatePage.jsx';
import ProjectsDetailPage from './pages/ProjectsDetailPage.jsx';
import Header from './components/Header.jsx';
import Footer from './components/Footer.jsx';
import PageNotFound from './pages/PageNotFound404.jsx';
import Login from './pages/auth/Login.jsx';
import Dashboard from './pages/auth/Dashboard.jsx';
import { useSelector } from 'react-redux';
import ProtectedRoute from './routers/ProtectedRoute';

//Admin 
import AdminUsers from './pages/users/Admin/AdminUsers.jsx';
import AdminSlider from './pages/users/Admin/AdminSlider.jsx';
import AdminProjeler from './pages/users/Admin/AdminProjeler.jsx';
import AdminReferanslar from './pages/users/Admin/AdminReferanslar.jsx';
import AdminNotification from './pages/users/Admin/AdminNotification.jsx';
import AdminProfile from './pages/users/Admin/AdminProfile.jsx';
import AdminKurumsal from './pages/users/Admin/AdminKurumsal.jsx';
import AdminHakkinda from './pages/users/Admin/AdminHakkinda.jsx';
import AdminIletisim from './pages/users/Admin/AdminIletisim.jsx';
import AdminKonum from './pages/users/Admin/AdminKonum.jsx';
import NewProjeler from './components/List/Project/NewProject.jsx';
import NewUser from './components/List/Project/NewUser.jsx';
import NewSlider from './components/List/Project/NewSlider.jsx';
import NewReferanslar from './components/List/Project/NewReferanslar.jsx';

const App = () => {
    const { user } = useSelector((state) => state.admin); // state.admin'dan user'ı alıyoruz
    return (
        <BrowserRouter>
            <Header />
            <Routes>
                <Route index path="/" element={<AnaSayfa />} />
                <Route path="/location" element={<LocationPage />} />
                <Route path="/communication" element={<CommunicationPage />} />
                <Route path="/contactus" element={<ContactusPage />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/projects" element={<ProjectsPage />} />/
                <Route path="/corporate" element={<CorporatePage />} />
                <Route path="/projects/:projectId" element={<ProjectsDetailPage />} />
                <Route path="/*" element={<PageNotFound />} />
                <Route path="/login" element={user ? <Dashboard /> : <Login />} />
                <Route path="/adminusers" element={user ? <ProtectedRoute><AdminUsers /></ProtectedRoute> : <Login />} />
                <Route path="/new-user" element={user ? <ProtectedRoute><NewUser /></ProtectedRoute> : <Login />} />
                <Route path="/adminslider" element={user ? <ProtectedRoute><AdminSlider /></ProtectedRoute> : <Login />} />
                <Route path="/new-slider" element={user ? <ProtectedRoute><NewSlider /></ProtectedRoute> : <Login />} />
                <Route path="/adminprojeler" element={user ? <ProtectedRoute><AdminProjeler /></ProtectedRoute> : <Login />} />
                <Route path="/new-project" element={user ? <ProtectedRoute><NewProjeler /></ProtectedRoute> : <Login />} />
                <Route path="/adminreferanslar" element={user ? <ProtectedRoute><AdminReferanslar /></ProtectedRoute> : <Login />} />
                <Route path="/new-referanslar" element={user ? <ProtectedRoute><NewReferanslar /></ProtectedRoute> : <Login />} />
                <Route path="/adminnotification" element={user ? <ProtectedRoute><AdminNotification /></ProtectedRoute> : <Login />} />
                <Route path="/adminkurumsal" element={user ? <ProtectedRoute><AdminKurumsal /></ProtectedRoute> : <Login />} />
                <Route path="/adminhakkinda" element={user ? <ProtectedRoute><AdminHakkinda /></ProtectedRoute> : <Login />} />
                <Route path="/adminiletisim" element={user ? <ProtectedRoute><AdminIletisim /></ProtectedRoute> : <Login />} />
                <Route path="/adminrekonum" element={user ? <ProtectedRoute><AdminKonum /></ProtectedRoute> : <Login />} />
                <Route path="/adminprofile" element={user ? <ProtectedRoute><AdminProfile /></ProtectedRoute> : <Login />} />
                <Route path="/dashboard" element={user ? <ProtectedRoute><Dashboard /></ProtectedRoute> : <Login />} />
            </Routes>
            <Footer />
        </BrowserRouter>
    )
}

export default App
